const src = require("/app/src/assets/images/svg/white-logo.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 184;
img.height = 56;
img.toString = function() { return src; };
module.exports = img;